(() => {
  const rootSelector = '[data-too-much-sale]';

  function initCarousel(carousel) {
    const scroller = carousel.querySelector('[data-too-much-scroller]');
    const slides = [...carousel.querySelectorAll('[data-too-much-slide]')];
    const dots = [...carousel.querySelectorAll('[data-too-much-dot]')];
    const prev = carousel.querySelector('[data-too-much-prev]');
    const next = carousel.querySelector('[data-too-much-next]');

    if (!scroller || slides.length < 2) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      return;
    }

    let index = 0;

    const updateChrome = () => {
      dots.forEach((dot, i) => {
        const selected = i === index;
        dot.setAttribute('aria-current', selected ? 'true' : 'false');
        dot.classList.toggle('is-active', selected);
      });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    };

    const setIndex = (nextIndex, behavior = 'smooth') => {
      index = Math.max(0, Math.min(slides.length - 1, nextIndex));
      const slide = slides[index];
      if (slide) {
        scroller.scrollTo({ left: slide.offsetLeft, behavior });
      }
      updateChrome();
    };

    prev?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      setIndex(index - 1);
    });
    next?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      setIndex(index + 1);
    });
    dots.forEach((dot, i) => {
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        setIndex(i);
      });
    });

    let ticking = false;
    scroller.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          const nearest = slides.reduce(
            (best, slide, i) => {
              const distance = Math.abs(slide.offsetLeft - scroller.scrollLeft);
              return distance < best.distance ? { i, distance } : best;
            },
            { i: 0, distance: Infinity }
          );
          if (nearest.i !== index) {
            index = nearest.i;
            updateChrome();
          }
          ticking = false;
        });
      },
      { passive: true }
    );

    updateChrome();
  }

  function openMiniCart() {
    if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
      window.Rebuy.SmartCart.show();
      return;
    }
    const miniCart = document.getElementById('mini-cart');
    if (miniCart) {
      miniCart.open = true;
    }
  }

  function initForms(root) {
    root.querySelectorAll('[data-too-much-form]').forEach((form) => {
      form.addEventListener('submit', () => {
        window.setTimeout(openMiniCart, 400);
      });
    });
  }

  function qtyByVariant(cart) {
    const map = {};
    (cart.items || []).forEach((item) => {
      const id = item.variant_id;
      map[id] = (map[id] || 0) + (item.quantity || 0);
    });
    return map;
  }

  function syncFromCart(cart) {
    if (!cart || typeof cart.total_price !== 'number') {
      return;
    }

    const quantities = qtyByVariant(cart);
    const total = cart.total_price;

    document.querySelectorAll('[data-too-much-card]').forEach((card) => {
      const variantId = parseInt(card.getAttribute('data-variant-id'), 10);
      const qty = quantities[variantId] || 0;

      const inCart = card.querySelector('[data-too-much-in-cart]');
      const count = card.querySelector('[data-too-much-in-cart-count]');
      if (inCart) {
        inCart.hidden = qty < 1;
      }
      if (count) {
        count.textContent = qty > 1 ? ` · ${qty}` : '';
        count.hidden = qty < 2;
      }

      const unlock = card.querySelector('[data-too-much-unlock]');
      if (unlock) {
        const threshold = parseInt(unlock.getAttribute('data-threshold'), 10);
        const addPrice = parseInt(unlock.getAttribute('data-add-price'), 10);
        const shouldShow =
          !Number.isNaN(threshold) &&
          threshold > 0 &&
          !Number.isNaN(addPrice) &&
          total < threshold &&
          total + addPrice >= threshold;
        unlock.hidden = !shouldShow;
      }
    });
  }

  let refreshTimer = null;
  function refreshFromServer() {
    if (refreshTimer) {
      clearTimeout(refreshTimer);
    }
    refreshTimer = setTimeout(() => {
      refreshTimer = null;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : null))
        .then((cart) => {
          if (cart) syncFromCart(cart);
        })
        .catch(() => {});
    }, 120);
  }

  function bindCartSync() {
    if (window.__tooMuchCartBound) {
      return;
    }
    window.__tooMuchCartBound = true;

    document.addEventListener('cart:updated', (event) => {
      if (event.detail && event.detail.cart && typeof event.detail.cart.total_price === 'number') {
        syncFromCart(event.detail.cart);
      } else {
        refreshFromServer();
      }
    });

    ['rebuy:cart.change', 'rebuy:smartcart.line-item-removed', 'rebuy.productsChange'].forEach((name) => {
      document.addEventListener(name, refreshFromServer);
    });
  }

  function init(root = document) {
    const section = root.querySelector?.(rootSelector) || (root.matches?.(rootSelector) ? root : null);
    const scope = section || document;
    scope.querySelectorAll('[data-too-much-carousel]').forEach(initCarousel);
    if (section || root === document) {
      initForms(scope);
    }
    bindCartSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
